export const PLP_SCROLL_POSITION = 'plpScrollPosition';
